import { useState } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link, useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { useIsMobile } from '@/common/hooks/useIsMobile';
import BurgerIcon from '@/common/svg/burger-icon.svg';
import Logo from '@/common/svg/logo-neo-credit.svg';
import { CallCenter } from '@/components/CallCenter';
import { LangSwitcher } from '@/components/LangSwitcher';
import Drawer from '@/entities/Drawer';
import { CustomButton } from '@/shared/CustomButton';
import { IconButton } from '@/shared/IconButton';
import { MainButton } from '@/shared/MainButton';

export const Header = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const token = localStorage.getItem('token');

  const [toggleDrawer, setToggleDrawer] = useState(false);

  const handleToggleDrawer = () => {
    setToggleDrawer((prev) => !prev);
  };

  const navigatePaymentsInfo = () => {
    navigate('/payments-info');
  };

  const navigatePayment = () => {
    navigate('/payment');
  };

  const navigateCabinet = () => {
    navigate('/auth');
  };

  return (
    <>
      <header className={styles.headerWrapper}>
        <div className={cn('container', styles.headerContainer)}>
          <div className={styles.left}>
            <Link id="logo-link-button" to="/">
              <Logo />
            </Link>
            {!isMobile && <CallCenter />}
            {!isMobile && <LangSwitcher />}
          </div>
          <div className={styles.right}>
            <div className={cn('desktop-display', styles.buttonsWrapper)}>
              <CustomButton
                id="header-payments-info"
                onClick={navigatePaymentsInfo}
              >
                <FormattedMessage defaultMessage="Способы оплаты" />
              </CustomButton>
              <CustomButton id="header-make-payment" onClick={navigatePayment}>
                <FormattedMessage defaultMessage="Внести оплату" />
              </CustomButton>
            </div>
            {!token && isMobile && (
              <MainButton
                id="header-sigin"
                className={styles.mainButton}
                text={<FormattedMessage defaultMessage="Войти" />}
                onClick={navigateCabinet}
              />
            )}
            {!isMobile && (
              <MainButton
                id="header-sigin"
                className={styles.mainButton}
                text={<FormattedMessage defaultMessage="Личный кабинет" />}
                onClick={navigateCabinet}
              />
            )}
            <IconButton
              id="toggle-drawer"
              Icon={BurgerIcon}
              onClick={handleToggleDrawer}
              className="mobile-display"
            />
          </div>
        </div>
      </header>
      {toggleDrawer && (
        <Drawer toggle={toggleDrawer} toggleHandler={handleToggleDrawer} />
      )}
    </>
  );
};
